<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ATTRIBUTE_CHANGED_EMPTY_VALUE } from 'dashboard/helper/filterQueryGenerator';
import MultiSelect from './MultiSelect.vue';

const { options } = defineProps({
  options: {
    type: Array,
    required: true,
  },
});

const { t } = useI18n();

const model = defineModel({
  type: Object,
  default: () => ({ from: [], to: [] }),
});

const fromValue = computed({
  get: () => (Array.isArray(model.value?.from) ? model.value.from : []),
  set: value => {
    model.value = { ...model.value, from: value };
  },
});

const toValue = computed({
  get: () => (Array.isArray(model.value?.to) ? model.value.to : []),
  set: value => {
    model.value = { ...model.value, to: value };
  },
});

const attributeChangedOptions = computed(() => {
  const emptyOption = {
    id: ATTRIBUTE_CHANGED_EMPTY_VALUE,
    name: t('FILTER.ATTRIBUTE_LABELS.NONE'),
  };

  if (options.some(option => option.id === ATTRIBUTE_CHANGED_EMPTY_VALUE)) {
    return options;
  }

  return [emptyOption, ...options];
});
</script>

<template>
  <div class="flex items-center gap-1">
    <span class="text-xs text-n-slate-11 shrink-0">
      {{ t('FILTER.ATTRIBUTE_CHANGED.FROM') }}
    </span>
    <MultiSelect
      v-model="fromValue"
      :options="attributeChangedOptions"
      :max-chips="2"
    />
    <span class="text-xs text-n-slate-11 shrink-0">
      {{ t('FILTER.ATTRIBUTE_CHANGED.TO') }}
    </span>
    <MultiSelect
      v-model="toValue"
      :options="attributeChangedOptions"
      :max-chips="2"
    />
  </div>
</template>
